/**
 * Takes the reader to the first field that failed — call it after a blocked submit.
 * A red line three screens down is a failure nobody sees; the caret landing in the
 * field is one they cannot miss. Deferred a tick so the errors just set have rendered.
 */
export default function focusFirstInvalid(root) {
  setTimeout(() => {
    const field = root?.querySelector('[aria-invalid="true"]')
    if (!field) return
    field.scrollIntoView({ block: 'center', behavior: 'smooth' })
    field.focus({ preventScroll: true })
  }, 0)
}
